import React, { memo } from "react";

import { makeStyles } from "@material-ui/styles";
import SvgIcon from "@material-ui/core/SvgIcon";

const useStyles = makeStyles({
  icon: {
    width: "1.063rem",
    height: "1rem",
  },
});

const AppsIcon = () => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 17 16" className={styles.icon}>
      <path
        d="M4.56403 2C4.56403 3.10457 3.6676 4 2.5618 4C1.456 4 0.55957 3.10457 0.55957 2C0.55957 0.895431 1.456 0 2.5618 0C3.6676 0 4.56403 0.895431 4.56403 2ZM10.5707 2C10.5707 3.10457 9.67428 4 8.56848 4C7.46268 4 6.56625 3.10457 6.56625 2C6.56625 0.895431 7.46268 0 8.56848 0C9.67428 0 10.5707 0.895431 10.5707 2ZM14.5752 4C15.681 4 16.5774 3.10457 16.5774 2C16.5774 0.895431 15.681 0 14.5752 0C13.4694 0 12.5729 0.895431 12.5729 2C12.5729 3.10457 13.4694 4 14.5752 4ZM4.56403 8C4.56403 9.10457 3.6676 10 2.5618 10C1.456 10 0.55957 9.10457 0.55957 8C0.55957 6.89543 1.456 6 2.5618 6C3.6676 6 4.56403 6.89543 4.56403 8ZM8.56848 10C9.67428 10 10.5707 9.10457 10.5707 8C10.5707 6.89543 9.67428 6 8.56848 6C7.46268 6 6.56625 6.89543 6.56625 8C6.56625 9.10457 7.46268 10 8.56848 10ZM16.5774 8C16.5774 9.10457 15.681 10 14.5752 10C13.4694 10 12.5729 9.10457 12.5729 8C12.5729 6.89543 13.4694 6 14.5752 6C15.681 6 16.5774 6.89543 16.5774 8ZM2.5618 16C3.6676 16 4.56403 15.1046 4.56403 14C4.56403 12.8954 3.6676 12 2.5618 12C1.456 12 0.55957 12.8954 0.55957 14C0.55957 15.1046 1.456 16 2.5618 16ZM10.5707 14C10.5707 15.1046 9.67428 16 8.56848 16C7.46268 16 6.56625 15.1046 6.56625 14C6.56625 12.8954 7.46268 12 8.56848 12C9.67428 12 10.5707 12.8954 10.5707 14ZM14.5752 16C15.681 16 16.5774 15.1046 16.5774 14C16.5774 12.8954 15.681 12 14.5752 12C13.4694 12 12.5729 12.8954 12.5729 14C12.5729 15.1046 13.4694 16 14.5752 16Z"
        fill="white"
        fillOpacity="0.87"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </SvgIcon>
  );
};

export default memo(AppsIcon);
